

exports.__esModule = true;

var _squid = require('squid');

var _directive = require('./directive');

var _directive2 = _interopRequireDefault(_directive);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = _squid.$Route.extend('$xoPasswordRecoveryOverlayRoute', {
    path: 'passwordRecovery',
    directive: _directive2['default'],
    trackingData: {
        fptiState: 'password_recovery'
    },
    children: []
});


_squid.$Route;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./components/xo-login-components/src/password-recovery-overlay/route.js
// module id = ./components/xo-login-components/src/password-recovery-overlay/route.js
// module chunks = 1